import { Reducer } from 'redux';
import { IPersistedMyClaimsFilters } from '../../types';

const initialState: IPersistedMyClaimsFilters = {
  selectedDate: new Date(),
  currentPage: 1,
  selectedStore: null,
  currentFilter: -1,
  search: '',
};

const persistMyClaimsFilters: Reducer<IPersistedMyClaimsFilters> =
(state: IPersistedMyClaimsFilters = initialState, action: any): IPersistedMyClaimsFilters => {
  if (action.type === 'MY_CLAIMS_LIST_FILTERS_PERSIST') {
    return {
      ...action.payload,
    };
  }
  return state;
};

export default persistMyClaimsFilters;
